import moment from "moment";
import React, { Fragment, useEffect, useState } from "react"
import 'react-image-lightbox/style.css';
import { toast } from "react-toastify";
import { Button, CardBody, Col, FormGroup, Table } from "reactstrap";
import iconSub from '../../../assets/images/icon-sub.png';
import profilePic from '../../../assets/images/users/no-img.jpg';
import ModalPopup from "../../../components/ModalPopup";
import NavTabNutri from "../../../components/NavTabNutri";
import { baseUrl } from "../../../constants/environment";
import APIClient from "../../../helpers/APIClient";
import PriceUtils from "../../../helpers/PriceUtils";
import BatchDetail from "../../batch/BatchDetail";
import { calTotalStockQuantity } from "../ProductBatchList";
import IconEdit from '../../../assets/images/icon-edit.png';
import { Loader } from "react-feather";
import { checkRole } from "../../../helpers/Roles";
import CalcUtils from "../../../helpers/CalcUltils";
import { AnyTxtRecord } from "dns";

const TABS = [
    {
        value:'stock',
        label: "Tồn kho"
    },
    {
        value:'batch',
        label: "Danh sách lô"
    },
    // {
    //     value:'history',
    //     label: "Lịch sử kho"
    // },
]

const ProductViewStock = (props: any) => {
    const [tab, setTab] = useState('stock');
    const tabs = TABS?.reduce((prev:any, item:any)=>{
        if(item?.value === 'batch'){
            if(props?.data?.type === 'batch'){
                prev = [...prev, item]
            }
        }else{
            prev = [...prev, item]
        }
        return prev
    },[])
    return (
        <div className="card">
            <div className="card-body">
                <NavTabNutri
                    {...props}
                    tabList={tabs}
                    setTab={(tab: string) => setTab(tab)}
                    tab={tab || 'stock'}
                    classes="mt-3 mb-0 nav-tab-full"
                />
                <div className="mt-4">
                    {tab === 'stock' && <TabStock {...props}/>}
                    {tab === 'batch' && <TabBatch {...props}/>}
                </div>
            </div>
        </div>
    )
}

const TabStock = (props: any) => {
    
    const { dataActive, data, branch, stockConfig } = props
    const productStockConfigLockup:any = {}
    stockConfig?.map((item:any)=>{
        if(!productStockConfigLockup[item?.sku]) productStockConfigLockup[item?.sku] = {}
        if(!productStockConfigLockup[item?.sku][item?.branch_id]) productStockConfigLockup[item?.sku][item?.branch_id] = {}
        productStockConfigLockup[item?.sku][item?.branch_id] = item
    })
    
    const productStockLockup:any = {}
    data?.product_stock?.map((item:any)=>{
        if(item?.variant_id){
            if(!productStockLockup[item?.variant_id?.sku]) productStockLockup[item?.variant_id?.sku] = {}
            if(!productStockLockup[item?.variant_id?.sku][item?.branch_id?.id]) productStockLockup[item?.variant_id?.sku][item?.branch_id?.id] = {}
            const itemPre = productStockLockup[item?.variant_id?.sku][item?.branch_id?.id]
            productStockLockup[item?.variant_id?.sku][item?.branch_id?.id] = {
                quantity: Number(itemPre?.quantity||0) + Number(item?.quantity),
            }
        }else{
            if(!productStockLockup[item?.product_id?.sku]) productStockLockup[item?.product_id?.sku] = {}
            if(!productStockLockup[item?.product_id?.sku][item?.branch_id?.id]) productStockLockup[item?.product_id?.sku][item?.branch_id?.id] = {}
            const itemPre = productStockLockup[item?.product_id?.sku][item?.branch_id?.id]
            productStockLockup[item?.product_id?.sku][item?.branch_id?.id] = {
                quantity: Number(itemPre?.quantity||0) + Number(item?.quantity),
            }
        }
    })
    const productStockTransferLockup:any = {}
    data?.product_stock_transfer?.map((item:any)=>{
        if(item?.variant_id){
            if(!productStockTransferLockup[item?.variant_id?.sku]) productStockTransferLockup[item?.variant_id?.sku] = {}
            if(!productStockTransferLockup[item?.variant_id?.sku][item?.branch_id?.id]) productStockTransferLockup[item?.variant_id?.sku][item?.branch_id?.id] = {}
            const itemPre = productStockTransferLockup[item?.variant_id?.sku][item?.branch_id?.id]
            productStockTransferLockup[item?.variant_id?.sku][item?.branch_id?.id] = {
                quantity: Number(itemPre?.quantity||0) + Number(item?.quantity),
            }
        }else{
            if(!productStockTransferLockup[item?.product_id?.sku]) productStockTransferLockup[item?.product_id?.sku] = {}
            if(!productStockTransferLockup[item?.product_id?.sku][item?.branch_id?.id]) productStockTransferLockup[item?.product_id?.sku][item?.branch_id?.id] = {}
            const itemPre = productStockTransferLockup[item?.product_id?.sku][item?.branch_id?.id]
            productStockTransferLockup[item?.product_id?.sku][item?.branch_id?.id] = {
                quantity: Number(itemPre?.quantity||0) + Number(item?.quantity),
            }
        }
    })
    const productStockHoldLockup:any = {}
    data?.product_stock_hold?.map((item:any)=>{
        if(item?.variant_id){
            if(!productStockHoldLockup[item?.variant_id?.sku]) productStockHoldLockup[item?.variant_id?.sku] = {}
            if(!productStockHoldLockup[item?.variant_id?.sku][item?.branch_id?.id]) productStockHoldLockup[item?.variant_id?.sku][item?.branch_id?.id] = {}
            const itemPre = productStockHoldLockup[item?.variant_id?.sku][item?.branch_id?.id]
            productStockHoldLockup[item?.variant_id?.sku][item?.branch_id?.id] = {
                quantity: Number(itemPre?.quantity||0) + Number(item?.quantity),
            }
        }else{
            if(!productStockHoldLockup[item?.product_id?.sku]) productStockHoldLockup[item?.product_id?.sku] = {}
            if(!productStockHoldLockup[item?.product_id?.sku][item?.branch_id?.id]) productStockHoldLockup[item?.product_id?.sku][item?.branch_id?.id] = {}
            const itemPre = productStockHoldLockup[item?.product_id?.sku][item?.branch_id?.id]
            productStockHoldLockup[item?.product_id?.sku][item?.branch_id?.id] = {
                quantity: Number(itemPre?.quantity||0) + Number(item?.quantity),
            }
        }
    })
    
    const RenderHeadData = () => {
        return (
            <thead>
                <tr>
                    <th className="text-center" style={{ minWidth: 60}}>Cơ sở</th>
                    <th className="text-center" style={{ minWidth: 60 }}>Tồn kho</th>
                    <th className="text-center" style={{ minWidth: 120 }}>Tạm giữ</th>
                    <th className="text-center" style={{ minWidth: 120 }}>Có thể bán</th>
                    <th className="text-center" style={{ minWidth: 120 }}>Tồn tối thiểu</th>
                    <th className="text-center" style={{ minWidth: 120 }}>Tồn tối đa</th>
                </tr>
            </thead>
        )
    }
    
    const RenderBobyData = () => {
        return (
            <tbody>
                {branch && branch?.length > 0 && branch?.map((item: any, index: number) => (
                    <RenderItem item={item} index={index} />
                ))}
            </tbody>
        )
    }

    const RenderItem = ({item, index}:any)=>{
        let color : any = ""
        let dataStock = productStockLockup && productStockLockup[dataActive?.sku] && productStockLockup[dataActive?.sku][item?.id]
        let dataStockTransfer = productStockTransferLockup && productStockTransferLockup[dataActive?.sku] && productStockTransferLockup[dataActive?.sku][item?.id]
        let dataStockHold = productStockHoldLockup && productStockHoldLockup[dataActive?.sku] && productStockHoldLockup[dataActive?.sku][item?.id]
        if(dataActive?.parent_id){
            const dataStockParent = productStockLockup && productStockLockup[dataActive?.parent_id?.sku] && productStockLockup[dataActive?.parent_id?.sku][item?.id]
            dataStock = {
                quantity: dataStockParent?.quantity ? Number(dataStockParent?.quantity) / Number(dataActive?.unit_value) : ''
            }
        }
        const dataStockConfig = productStockConfigLockup && productStockConfigLockup[dataActive?.sku] && productStockConfigLockup[dataActive?.sku][item?.id]
        
        const stock_quantity_is_sale = Number(dataStock?.quantity || 0) - Number(dataStockTransfer?.quantity || 0) - Number(dataStockHold?.quantity || 0)
        
        const checkInventory = () => {
            if(!dataStockConfig?.stock_min ||dataStockConfig?.stock_min == undefined) {
                if(dataStock?.quantity == 0 || dataStock?.quantity  == undefined){
                    color = "red"
                    return <span style={{color : "#FF0000"}}>Sản phẩm đã hết hàng</span>
                }else if( 0 < dataStock?.quantity && dataStock?.quantity <= 5){
                    color = "blue"
                   return <span style={{color : "#F19C1D"}}>Sản phẩm sắp hết hàng</span>
                }  
            }else if (dataStockConfig?.stock_min) {
                if(dataStock?.quantity == 0 || dataStock?.quantity == undefined){
                    color = "#FF0000"
                    return <span style={{color : "#FF0000"}}>Sản phẩm đã hết hàng</span>
                }else if( 0 < dataStock?.quantity && dataStock?.quantity  <= dataStockConfig?.stock_min){
                    color = "#F19C1D"
                    return <span style={{color : "#F19C1D"}}>Sản phẩm sắp hết hàng</span>
                } else {
                    return <span ></span>
                }
            }
        }

        return (
            <tr key={`${item?.id}-${index}`}>
                <td>{item?.name} <br />
                {checkInventory()}
                </td>
                <td className="text-center" style={{color : `${color}`}}>
                    {PriceUtils.format(dataStock?.quantity , '') || '---'}
                </td>
                <td className="text-center" style={{color : `${color}`}}>
                    {PriceUtils.format(dataStockHold?.quantity , '') || '---'}
                </td>
                <td className="text-center" style={{color : `${color}`}}>
                    {PriceUtils.format(stock_quantity_is_sale , '') || '---'}
                </td>
                <td className="text-center" style={{color : `${color}`}}>
                    {PriceUtils.format(dataStockConfig?.stock_min , '') || '---'}
                </td>
                <td className="text-center" style={{color : `${color}`}}>
                    {PriceUtils.format(dataStockConfig?.stock_max , '') || '---'}
                </td>
            </tr>
        )
    }
    return (
        <div className="mt-4">
            <Table className="mb-0 table-custom" responsive>
                <RenderHeadData />
                <RenderBobyData />
            </Table>
        </div>
    )
}

const TabBatch = (props: any) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [action, setAction] = useState<any>({});
    useEffect(()=>{
        loadData()
    },[props?.dataActive])

    const loadData = async () => {
        const variant = props?.data?.product_variants?.filter((item:any)=>{
            return item?.sku === props?.dataActive?.sku
        })
        const url = `${baseUrl}/product-batch`;
        let response: any = await APIClient.GET(url, {
            product_id: props?.data?.id,
            variant_id: variant && variant[0] && variant[0]?.id || undefined,
            page: 1,
            limit: 1000,
        });
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error)
        } else if (response.response?.data !== undefined) {
            setData(response?.response?.data)
        }
    }

    const handleActionModal = (item: any) => {
        setAction(item)
        setIsOpen(true);
    }
    const RenderHeadData = () => {
        return (
            <thead>
                <tr>
                    <th className="text-center" style={{ minWidth: 120 }}>Mã lô</th>
                    <th className="text-center" style={{ minWidth: 120 }}>Ngày sản xuất</th>
                    <th className="text-center" style={{ minWidth: 120 }}>Ngày hết hạn</th>
                    <th className="text-center" style={{ minWidth: 120 }}>Tồn kho</th>
                    <th className="text-center" style={{ minWidth: 120 }}>Trạng thái</th>
                    <th className="text-center" style={{ minWidth: 120 }}>Hành động</th>
                </tr>
            </thead>
        )
    }
    
    const RenderBobyData = () => {
        return (
            <tbody>
                {data && data?.length > 0 && data?.map((item: any, index: number) => (
                    <RenderItem item={item} index={index} />
                ))}
            </tbody>
        )
    }

    const RenderItem = ({item, index}:any)=>{
        const totalStockQuantity = calTotalStockQuantity(item?.stock_quantity)
        const gotoDetail = (item:any) => {
            handleActionModal({type: 'view', data: item})
        }
        const calExpiry = CalcUtils.getExpiryStatus(item?.expiration_date)
        return (
            <tr key={`${item?.id}-${index}`}>
                <td onClick={() => gotoDetail(item)}>{item?.name}</td>
                <td onClick={() => gotoDetail(item)} className="text-center">{item?.production_date ? moment(item?.production_date).format('DD/MM/YYYY') : '---'}</td>
                <td onClick={() => gotoDetail(item)} className="text-center">{item?.expiration_date ? moment(item?.expiration_date).format('DD/MM/YYYY') : '---'}</td>
                <td onClick={() => gotoDetail(item)} className="text-center">
                    <div style={{
                        display: "flex",
                        justifyContent: "space-around"
                    }}>
                        <span style={{flex:1}}>{PriceUtils.format(totalStockQuantity , '') || '---'} </span>
                        <b style={{ color: '#48a81d', flex:1}}>Chi tiết</b>
                    </div>
                </td>
                <td onClick={() => gotoDetail(item)} className="text-center">
                    <span className={calExpiry?.calssName}>{calExpiry?.title}</span>    
                </td>
                <td>
                    <div className="table-action">
                        <div className="button-nutri" onClick={() => handleActionModal({type: 'edit', data: item})}>
                            <img style={{border: 'none'}} src={IconEdit} width={20} height={20} alt=""/>
                        </div>
                        <div className="button-nutri" onClick={() => handleActionModal({type: 'delete', data: item})}><i className='uil-trash-alt'></i></div>
                    </div>
                </td>
            </tr>
        )
    }

    const RenderActionModal = (props: any) => {
        const [loading, setLoading] = useState(false);
        const { closeModal, action, loadData } = props
    
        const handleDelete = async() => {
            setLoading(true)
            const url = `${baseUrl}/product-batch/${action?.data?.id}`;
            let response: any = await APIClient.DELETE(url);
            setLoading(false)
            if (response.error !== undefined) {
                toast.error(response.error.error_description)
            } else if (response.response !== undefined) {
                toast.success('Xóa lô thành công')
                closeModal();
                loadData()
            }
        }
    
        if(!checkRole(props?.user?.roles, ['batchEdit'], props?.user?.role)){
            return (
                <CardBody className='p-0' style={{width:460}}>
                    <div className="modal-header">
                        <h5 className="modal-title" id="modal-action-title">
                            Thông báo
                        </h5>
                        <button onClick={()=>closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
                    </div>
                    <div className="modal-body pt-2 pb-2">
                        <Col md={12}>
                            <FormGroup row className="label-only">
                                <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>
                                    Bạn không có quyền thực hiện thao tác này
                                </p>
                            </FormGroup>
                        </Col>
                    </div>
                    <div className="modal-footer">
                        <Button
                            onClick={closeModal}
                            className="ml-2 success-bland" color="success" type="button"
                        > Hủy bỏ</Button>
                    </div>
                    {loading && <Loader />}
                </CardBody>
        
            )
        }
    
        return (
            <CardBody className='p-0' style={{width:400}}>
                <div className="modal-header">
                    <h5 className="modal-title" id="modal-action-title">
                        {
                        action?.type === 'delete' ? "Xóa lô" 
                        : "Thông báo"
                        }
                    </h5>
                    <button onClick={()=>closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
                </div>
                <div className="modal-body pt-2 pb-2">
                    <Col md={12}>
                        <FormGroup row className="label-only">
                            {action?.type === 'delete' &&
                                <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>
                                    Bạn có chắc chắn muốn xóa lô này không?
                                </p>
                            }
                        </FormGroup>
                    </Col>
                </div>
                <div className="modal-footer">
                    <Button
                        onClick={()=>{
                            action?.type === 'delete' && handleDelete()
                        }}
                        className="ml-2" color="success" type="button"
                    > Xác nhận </Button>
                </div>
                {loading && <Loader />}
            </CardBody>
    
        )
    }

    return (
        <div className="mt-4">
            <Table className="mb-0 table-custom" responsive>
                <RenderHeadData />
                <RenderBobyData />
            </Table>
            <ModalPopup
                isOpen={modalIsOpen}
                onRequestClose={() => setIsOpen(false)}
            >
                {(action?.type === 'edit' || action?.type === 'view') ?
                    <BatchDetail closeModal={() => setIsOpen(false)} action={action} loadData={() => loadData()} batch_id={action?.data?.id} />:
                    <RenderActionModal {...props} closeModal={() => setIsOpen(false)} action={action} loadData={() => loadData()}/>
                }
            </ModalPopup>
        </div>
    )
}

export default ProductViewStock
